export const stringToInteger = (value: string): number => {
  if (typeof value === 'number') {
    return value;
  }

  const withCorrectDecimalMarker = value.replace(/\s/g, '').replace(',', '.');

  return parseFloat(withCorrectDecimalMarker);
};
